import { ROUTE_COLUMN_ICONS } from "./constants";
import { findIcon } from "../icons";

const getColumnsByRoute = (route) => ROUTE_COLUMN_ICONS[route];

export const routeHasIcons = (route) =>
  Object.keys(ROUTE_COLUMN_ICONS).find((i) => route.includes(i));

export const columnHasIcons = (route, column) => {
  const routes = Object.keys(getColumnsByRoute(route));
  return routes ? routes.includes(column) : false;
};

export const getIconMap = (route, column) => {
  const columns = getColumnsByRoute(route);
  return columns ? columns[column] : null;
};

export const getIcon = (config, text = "") => {
  if (_.isString(config)) {
    return generateIcon(config, text);
  } else {
    const { icon, style = {} } = config;
    if (icon) {
      return generateIcon(icon, text, style);
    }
  }
};

const generateIcon = (label, text = "", iconConfig = {}) => {
  const style = `
		display: flex;
		flex-direction: column;
		align-items: center;
	`;
  const Icon = findIcon(label, iconConfig);
  return Icon ? `<span title="${text}" style="${style}">${Icon}</span>` : label;
};
